import { t } from "./i18n/index.ts";

/** Pegman-style mark for Naver street view in a new tab. */
export const STREET_VIEW_ICON_SVG =
  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><circle cx="12" cy="6.5" r="2.5" fill="currentColor"/><path d="M8.5 21v-7l-1.2-4.2a2 2 0 0 1 1.9-2.6h6.6a2 2 0 0 1 1.9 2.6L16.5 14v7" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M10 11.5h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

export const PLUS_ICON =
  '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';
export const MINUS_ICON =
  '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';

/** Centered X for square map/modal close controls (avoid × font metrics). */
export const CLOSE_ICON_SVG =
  '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

export const LIGHTBOX_PREV_ICON =
  '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M14 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export const LIGHTBOX_NEXT_ICON =
  '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M10 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export function mapControlButton(className: string, label: string, icon: string, onPress: () => void): HTMLButtonElement {
  const b = document.createElement("button");
  b.type = "button";
  b.className = className;
  b.title = label;
  b.setAttribute("aria-label", label);
  b.innerHTML = icon;
  b.addEventListener("click", (e) => {
    e.stopPropagation();
    onPress();
  });
  return b;
}

export function createMapStreetViewButton(): HTMLButtonElement {
  const label = t("rt.map.openStreetView");
  const b = document.createElement("button");
  b.type = "button";
  b.className = "route-map-streetview";
  b.title = label;
  b.setAttribute("aria-label", label);
  b.innerHTML = STREET_VIEW_ICON_SVG;
  return b;
}

export function mapZoomGroup(zoomOut: HTMLButtonElement, zoomIn: HTMLButtonElement): HTMLDivElement {
  const zoom = document.createElement("div");
  zoom.className = "route-map-zoom";
  zoom.setAttribute("role", "group");
  zoom.setAttribute("aria-label", t("rt.map.zoom"));
  zoom.append(zoomOut, zoomIn);
  return zoom;
}
